/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Money_LabelInputs */

const en_services_svc_money_label = /** @type {(inputs: Services_Svc_Money_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make money`)
};

const lv_services_svc_money_label = /** @type {(inputs: Services_Svc_Money_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelniet vairāk`)
};

/**
* | output |
* | --- |
* | "Make money" |
*
* @param {Services_Svc_Money_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_money_label = /** @type {((inputs?: Services_Svc_Money_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Money_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_money_label(inputs)
	return en_services_svc_money_label(inputs)
});